import { IProduct } from '../../types/product';
import ButtonBordered from '../../components/common/Buttons/ButtonBordered';
import IconButton from '../../components/common/Buttons/IconButton';
import { Roles } from '../../utils/enums';

interface BottombarProps {
    products: Array<IProduct>;
    handlePrimaryButton: (e?) => void;
    handleSecondaryButton: (e?) => void;
    productId: string;
    userType?: string;
}

export default function Bottombar({ productId, handlePrimaryButton, handleSecondaryButton, userType }: BottombarProps) {
    return (
        <div className="container flex justify-between">
            <div className="">
                <h1 className="text-gray-500 whitespace-no-wrap text-sm uppercase">current Product</h1>
                <div className="text-gray-900 whitespace-no-wrap text-lg uppercase">{productId}</div>
            </div>
            <div className="flex justify-end gap-4 w-1/3">
                <ButtonBordered fullWidth label="Download Model" onClick={handleSecondaryButton} />

                {userType === Roles.REQUESTOR && (
                    <IconButton fullWidth label="Approve Model" onClick={handlePrimaryButton}>
                        <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.0001 7.2799L1.2201 4.4999L0.273438 5.4399L4.0001 9.16656L12.0001 1.16656L11.0601 0.226562L4.0001 7.2799Z" fill="white" />
                        </svg>
                    </IconButton>
                )}
            </div>
        </div>
    );
}
